<template>
    <div
        class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
    >
        <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-400 h-12 w-12 mb-4"></div>
        <h2 class="text-center text-white text-[14px] font-semibold">
            Loading...
        </h2>
        <p class="w-1/3 text-center text-white">
            資料傳輸中，請勿重整或關閉網頁
        </p>
    </div>
</template>

<script>
/**
 * Loading...資料傳輸中，請勿重整或關閉網頁
 */
export default {
    name: 'LoadingOverlay'
};
</script>